// LuckyBet Toggle Button

luckyBetToggleButton = {};

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  button._flags.showLuckyBetActive = false;

  button.canPlaceBet = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canShow = function () {
    // Dont show in freespins
    return !freespins.inFreespins && this._flags.platformVisible;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;
    const goldenbetStakes = this.gameConfig.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes;
    const baseStake = resourceManager.getController('stakeController').BaseStake / 20;

    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    var buttonToDim = button._flags.showLuckyBetActive ? this.button.buttonEnabled : this.button.buttonDisabled;

    buttonToDim.alpha = allow ? 1 : 0.5;

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;

    this.gameConfig = config;
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe('spinner:GameConfigEvent', function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe('spinner:GameConfigEvent', button.onConfig.bind(button));
    messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
    messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));
  };

  button.onLayoutComplete = function () {
    // this.emitter = particleManager.createEmitter(
    //   "luckyBetEmitter",
    //   "buttonContainer:buttonBar:luckyBetToggleButton:button:particlesContainer",
    //   0,
    //   -10,
    //   false
    // );
    // this.emitter.particleEmitter.emit = false;

    button.luckyBetMessage = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage');
    button.animParent = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
    button.animParentPortrait = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButtonPortrait');

    resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage').alpha = 0;

    // Chest open animation
    button.luckyBetAnim = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:goldenBetAnim');
    button.luckyBetAnimPortrait = resourceManager.get(
      'buttonContainer:buttonBar:luckyBetToggleButtonPortrait:goldenBetAnimPortrait'
    );
    button.luckyBetAnim.visible = false;
    button.luckyBetAnimPortrait.visible = false;
    button.messageAnim = undefined;

    Reflex.registerEventHandler('orientationChange', button.onOrientationChange.bind(this));
  };

  button.onOrientationChange = function () {
    let messageText = resourceManager.get(
      'buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:luckyBetMessageTextContainer'
    );
    messageText.scale.set(1, 1);
    messageText.position.set(-462, 143);
  };

  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable lucky bet
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();

    // this.emitter.particleEmitter.emit = false;
  };

  button.cancelLuckyBet = function () {
    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      button.luckyBetAnim.gotoAndStop(0);
      button.luckyBetAnimPortrait.gotoAndStop(0);
      // this.emitter.particleEmitter.emit = false;

      gameData.encoreEnabled = false;

      button.handleStakeChange();
    }
  };

  button.handleStakeChange = function () {
    let bpl = resourceManager.getController('stakeController').BaseStake / 25;
    let luckyBetEnabled = gameData.encoreEnabled;
    resourceManager.getController('stakeController').setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(resourceManager.getController('stakeController').BaseStake * (luckyBetEnabled ? 1.5 : 1), bpl);
    resourceManager.getController('stakeController').broadcastCurrentStake();
  };

  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as lucky bet active
    button._flags.showLuckyBetActive = true;
    gameData.encoreEnabled = true;
    if (gameData.encoreEnabled) {
      let toggle = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:button');
      let togglePortrait = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButtonPortrait:button');
      toggle.alpha = 1;
      toggle.interactive = true;
      togglePortrait.alpha = 1;
      togglePortrait.interactive = true;
    }
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;
    if (layoutController.getCurrentLayout() === 'portrait_default') {
      resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton')._flags.showLuckyBetActive =
        button._flags.showLuckyBetActive;
    } else if (
      layoutController.getCurrentLayout() === 'landscape_default' ||
      layoutController.getCurrentLayout() === 'landscape_mobile'
    ) {
      resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButtonPortrait')._flags.showLuckyBetActive =
        button._flags.showLuckyBetActive;
    }

    game.resetWinnings();

    if (button._flags.showLuckyBetActive) {
      let toggle = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:button');
      let togglePortrait = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButtonPortrait:button');

      if (button.luckyBetMessage !== undefined) {
        button.luckyBetMessage.alpha = 1.0;

        button.messageAnim = gsap.fromTo(
          [
            resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:luckyBetFrame').scale,
            resourceManager.get(
              'buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:luckyBetMessageTextContainer'
            ).scale,
          ],
          { x: 0, y: 0 },
          {
            x: 1,
            y: 1,
            duration: 0.4,
            ease: 'bounce.out',
          }
        );

        button.luckyBetAnim.visible = true;
        button.luckyBetAnimPortrait.visible = true;
        toggle.alpha = 0;
        togglePortrait.alpha = 0;

        // Show anim over button briefly
        timerManager.addTimer(
          1000,
          function () {
            toggle.interactive = false;
            togglePortrait.interactive = false;
          },
          function () {
            button.luckyBetAnim.visible = false;
            button.luckyBetAnimPortrait.visible = false;
            toggle.alpha = 1;
            toggle.interactive = true;
            togglePortrait.alpha = 1;
            togglePortrait.interactive = true;
          }
        );

        button.outerFadeTimer = timerManager.addTimer(2500, undefined, function () {
          button.innerFadeTimer = timerManager.addTimer(
            250,
            function (progress) {
              button.luckyBetMessage.alpha = 1 - progress;
            },
            function () {
              button.luckyBetMessage.alpha = 0.0;
            }
          );
        });

        button.luckyBetAnim.gotoAndPlay(0);
        button.luckyBetAnimPortrait.gotoAndPlay(0);
        // this.emitter.particleEmitter.emit = true;
        soundManager.play('activateGoldenBet');

        gameData.encoreEnabled = true;
        button.handleStakeChange();
      }
    } else {
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
        soundManager.play('cancelGoldenBet');
      }
    }
  };

  return button;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'luckyBetToggleButton',
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
